import * as React from "react";

;
export const AssetActionAddSmll = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.75 20V4h-1.5v7.25H4v1.5h7.25V20h1.5zM20 12.75h-6v-1.5h6v1.5z" fill="#100722" /></svg>;